<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 1.5H5V3.5H3V1.5ZM3 4.5H5V6.5H3V4.5Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linejoin="round"
    />
  </svg>
</template>
